import { NativeSelect, useBreakpointValue } from '@chakra-ui/react'
import { useTranslation, AVAILABLE_LANGUAGES } from '../i18n'

// Shared by the app header and the moderation toolbar. The moderation screen
// runs without the app chrome — it needs every pixel for video — so the few
// controls that chrome carried have to be reachable from its own overflow menu.

export function LanguageSwitcher() {
  const { lang, setLang, t } = useTranslation()
  // On mobile, show a compact flag-only selector to save horizontal space.
  const compact = useBreakpointValue({ base: true, md: false })
  return (
    <NativeSelect.Root size="xs" width={{ base: '56px', md: '110px' }}>
      <NativeSelect.Field
        aria-label={t('language.label')}
        value={lang}
        onChange={(e) => setLang(e.target.value)}
        bg="var(--mc-bg-raised)"
        borderColor="var(--mc-border)"
        color="var(--mc-text)"
        fontFamily="'JetBrains Mono', monospace"
        fontSize="xs"
      >
        {AVAILABLE_LANGUAGES.map((l) => (
          <option key={l.code} value={l.code}>{compact ? l.flag : l.label}</option>
        ))}
      </NativeSelect.Field>
      <NativeSelect.Indicator />
    </NativeSelect.Root>
  )
}
